import { render, staticRenderFns } from "./SQuesFortyNine.vue?vue&type=template&id=bc3b4d34&"
import script from "./SQuesFortyNine.vue?vue&type=script&lang=js&"
export * from "./SQuesFortyNine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports